import {ApiRequestHandlerOptions, RequestHandler} from '../../types';
import {Dictionary} from '@malt/types-utils';
import {appContextOptions} from './../appContextOptions';
import {findResourceLink} from '../endpoints';

export function defineCreateEndpoint(appId: string) {
    function createEndpoint<TResult = void, TParams extends Dictionary = never>(
        endpoint: string,
        options?: ApiRequestHandlerOptions,
    ): RequestHandler<TResult, TParams> {
        async function returnedRequestHandler(params?: TParams): Promise<TResult> {
            const {useAppContext, $fetch} = appContextOptions.instances.get(appId)!;
            const {pinia} = appContextOptions;
            const appContext = useAppContext(pinia);
            const providedLinks = options?.overrideLinks ?? appContext._links;
            const logger = options?.logger ?? true;
            const resourceLink = findResourceLink(endpoint, providedLinks);

            if ((!options?.overrideLinks && !appContext._links) || !resourceLink) {
                console.warn(`Cannot find endpoint ${endpoint} in registry. Try checking if it exists at runtime with the "endpointExists" export`);
                return null as any;
            } else {
                if (options?.method) {
                    resourceLink.type = options.method;
                }

                let url = resourceLink.href;
                let paramsWithoutPathVariable: Record<string, any> | undefined;

                const ARG_REGEXP = /{.*?}/g;
                if (url.match(ARG_REGEXP) && params) {
                    const paramsKeys = Object.keys(params);
                    if (paramsKeys.length > 0) {
                        paramsWithoutPathVariable = {};

                        paramsKeys.forEach((key) => {
                            const routeParam = `{${key}}`;
                            if (url.includes(routeParam)) {
                                url = url.replace(routeParam, params[key]);
                            } else {
                                paramsWithoutPathVariable![key] = params[key];
                            }
                        });
                    }
                } else {
                    paramsWithoutPathVariable = params;
                }

                return (await $fetch({method: resourceLink.type!, url}, paramsWithoutPathVariable, logger)) as any;
            }
        }
        return returnedRequestHandler as any;
    }

    return createEndpoint;
}
